module.exports = __webpack_public_path__ + "media/assets/svgs/emailIcon-1484812ff4071f1e311f6679d4aa6629.svg";